module.exports = __webpack_public_path__ + "img/80016.19a93f70.png";